import axios from './axios'

export const list = params => axios.get('/management/freightTemplates', { params })
export const detail = id => axios.get(`/management/freightTemplates/${id}`)
export const create = form => axios.post('/management/freightTemplates', form)
export const update = (id, form) => axios.put(`/management/freightTemplates/${id}`, form)
export const deleteById = id => axios.delete(`/management/freightTemplates/${id}`)
export const getConfig = () => axios.get('/management/freightRule')
export const updateConfig = (data) => axios.put('/management/freightRule', data)
